import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function CloseSection() {
  return <section className="py-24 px-6 bg-midnight text-center relative overflow-hidden" data-id="element-1">
      {/* Subtle glow at bottom */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-64 bg-amber/5 blur-[100px] pointer-events-none" data-id="element-2" />

      <div className="max-w-2xl mx-auto space-y-10 relative z-10" data-id="element-3">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="space-y-6" data-id="element-4">
          <h2 className="text-3xl md:text-4xl font-heading text-cream" data-id="element-5">
            No te prometo que nunca más te vas a despertar.
          </h2>

          <p className="text-xl text-cream-dim" data-id="element-6">Te prometo algo más útil:</p>

          <p className="text-2xl md:text-3xl font-heading text-amber italic leading-relaxed py-6" data-id="element-7">
            Que la próxima vez que pase… <br data-id="element-8" />
            no te vas a quedar sola improvisando en tu cabeza.
          </p>

          <p className="text-xl text-cream" data-id="element-9">Vas a tener un protocolo.</p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2,
        duration: 0.5
      }} className="pt-8" data-id="element-10">
          <CTAButton href="https://rutinasimple.com/cart/51971920527641:1" data-id="element-11">
            Obtener Reset 3AM — US$6.39
          </CTAButton>
        </motion.div>
      </div>
    </section>;
}